import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { AdminSideNavComponent } from './navigation/side-nav-bar/admin-side-nav/admin-side-nav.component';
import { NonAdminSideNavComponent } from './navigation/side-nav-bar/non-admin-side-nav/non-admin-side-nav.component';
import { OpenComponent } from './navigation/top-nav-bar/open/open.component';
import { LoggedOutHeaderComponent } from './headers/logged-out-header/logged-out-header.component';
import { LoggedInHeaderComponent } from './headers/logged-in-header/logged-in-header.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreatePasswordComponent } from './auth/create-password/create-password.component';



@NgModule({
  declarations: [FooterComponent, AdminSideNavComponent, NonAdminSideNavComponent, OpenComponent, LoggedOutHeaderComponent, LoggedInHeaderComponent, CreatePasswordComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    FooterComponent, AdminSideNavComponent, NonAdminSideNavComponent, OpenComponent, LoggedOutHeaderComponent, LoggedInHeaderComponent
  ]
})
export class CoreModule { }
